// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_e-2";
export var blackBorderOnHover = "_e-7";
export var cell = "_e-6";
export var cellContainer = "_e-3";
export var checked = "_e-8";
export var disabled = "_e-5";
export var featuredIconCellContainer = "_e-9";
export var featuredIconTextContainer = "_e-b";
export var featuredIconWrapper = "_e-a";
export var noBorder = "_e-c";
export var orangeSelectedRow = "_w-3";
export var overflowableText = "_e-0";
export var overflowableTextContainer = "_e-1";
export var row = "_d-0";
export var rowCheckboxCell = "_e-4";
export var selectableTable = "_w-2";